import Audio from '~/Audio';
import { logError } from '~/logger';
import messages, { GameStateStoreMessage } from '~/flux/stores/GameStateStore/messages';
import mutationEquipBagToGlobalBagSlot from '~/graphql/game-items/mutationEquipBagToGlobalBagSlot';

export default async function equipBagToGlobalBagSlot(
  {
    playerId,
    setInventoryAndHeroRoster,
    emit,
  }: {
    playerId: string;
    setInventoryAndHeroRoster: (data: { inventory?: unknown; hero_roster?: unknown }) => void;
    emit: (event: GameStateStoreMessage) => void;
  },
  action: { from: any; to: any }
) {
  try {
    const data = await mutationEquipBagToGlobalBagSlot({
      playerId,
      from: {
        location: action.from.location,
        heroHandle: action.from.hero_handle,
        bagSlotIndex: action.from.bag_slot_index,
        bagIndex: action.from.bag_index,
        bagItemIndex: action.from.bag_item_index,
      },
      to: {
        location: action.to.location,
        heroHandle: action.to.hero_handle,
        bagSlotIndex: action.to.bag_slot_index,
        bagIndex: action.to.bag_index,
        bagItemIndex: action.to.bag_item_index,
      },
    });

    setInventoryAndHeroRoster({
      ...(data.inventory != null && { inventory: data.inventory }),
      ...(data.heroRoster != null && { hero_roster: data.heroRoster }),
    });

    emit(messages.EQUIPMENT_CHANGE);
    Audio.play('equipment_storage');
  } catch (err) {
    logError(err, {
      module: 'GameStateStore',
      func: 'equipBagToGlobalBagSlot',
      playerId,
      action: JSON.stringify(action),
    });
  }
}
